module.exports = __webpack_public_path__ + "68caf08996ab1089815d210d382476d0.png";